import request from '@host-panel/request';

import { BulkAction, GetBulkActionsStatusResponse, GetRunningBulkActionsResponse } from '../types/articleItem';

export async function postBulkAction(action: BulkAction, postId: string): Promise<void> {
  return await request(`/host-panel/mba/job/${action}`, {
    method: 'POST',
    headers: { 'x-post-id': postId }
  });
}

export async function fetchBulkActionsStatus(postIds: Array<string>): Promise<GetBulkActionsStatusResponse> {
  return await request('/host-panel/mba/job/status', {
    method: 'POST',
    data: { postIDs: postIds }
  });
}

export async function getRunningBulkActionsRequests(): Promise<GetRunningBulkActionsResponse> {
  return await request('/host-panel/mba/job/running', {
    method: 'GET'
  });
}
